import {
  createElement,
  forwardRef,
  RefAttributes,
  ForwardRefExoticComponent,
  PropsWithoutRef,
  ComponentType,
  ComponentRef,
  ComponentProps,
} from 'react';
import { ErrorBoundary, ErrorBoundaryProps } from 'react-error-boundary';

import RuntimeError from 'pages/RuntimeError';

// Based on https://github.com/bvaughn/react-error-boundary/blob/master/src/withErrorBoundary.ts
export function withModuleErrorBoundary<T extends ComponentType<any>>(
  component: T
): ForwardRefExoticComponent<
  PropsWithoutRef<ComponentProps<T>> & RefAttributes<ComponentRef<T>>
> {
  const errorBoundaryProps: ErrorBoundaryProps = {
    FallbackComponent: RuntimeError,
  };

  const Wrapped = forwardRef<ComponentRef<T>, ComponentProps<T>>((props, ref) =>
    createElement(
      ErrorBoundary,
      errorBoundaryProps,
      createElement(component, { ...props, ref })
    )
  );

  // Format for display in DevTools
  const name = component.displayName || component.name || 'Unknown';
  Wrapped.displayName = `withErrorBoundary(${name})`;

  return Wrapped;
}
